// This file is used to map the fields for the NGL Wisconsin Disclosure Statement Form
import { getNGLFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/NGLFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'

export default class NGLWIDisclosureStatement {
	private fieldNameProvider = getNGLFieldNames()

	// Standard list of fields for this form.
	// These values point to field names in the fieldNameProvider, as well as functions to get the value for the field via the fieldValueProvider
	private fields: (keyof typeof this.fieldNameProvider)[] = [
		'funeralHomeRepresentativePrintedName',
		'funeralHomeFullAddress',
	]

	private unfilledFields = [
		'funeralHomeRepresentativeSignatureDate',
		'purchaserSignatureDate',
		'purchaserSignature',
		'funeralHomeRepresentativeSignature',
	]

	// Setup prior to building form filling array.
	constructor(planHolderId: string) {
		const { identitySetup } = useIdentitySetup()
		const { setFieldNameProvider } = useFormFillHelper()

		identitySetup(planHolderId, ['planHolder', 'funeralHome', 'salesContact'])
		setFieldNameProvider(this.fieldNameProvider)
	}

	// Build form filling array.
	getFormMappings() {
		const { mapFields } = useFormFillHelper()

		return mapFields(this.fields)
	}
}
